import { useState } from "react";
import { useParams } from "react-router-dom";

import { Button, LoadingState, SectionHeader } from "~/common/components";
import { BUTTON_SIZES } from "~/common/constants";
import { useIsTeamMemberStaff } from "~/providers/hooks";
import { useGetPatientCarePlansList } from "~/providers/hooks/queries/teamMemberPaymentAndCarePlans/myCarePlans/useGetPatientCarePlansList";
import { PatientParams } from "~/providers/utils";
import { CarePlansCard, ChangePlanModal } from "../carePlans";
import { CurrentCarePlanEmptyState } from "./CurrentCarePlanEmptyState";

export const CurrentCarePlan = () => {
  const { patientId } = useParams<keyof PatientParams>() as PatientParams;
  const { data: carePlans, isLoading } = useGetPatientCarePlansList(patientId);
  const [currentPlanModal, setCurrentPlanModal] = useState(false);
  const { isStaff } = useIsTeamMemberStaff();

  const toggleCurrentPlanModal = () => setCurrentPlanModal((prev) => !prev);

  if (isLoading) return <LoadingState />;
  if (!carePlans?.length) return <CurrentCarePlanEmptyState />;

  const currentCarePlan = carePlans[0];

  return (
    <>
      <div className="flex flex-col gap-6 border-y py-6">
        <div className="flex justify-between">
          <SectionHeader>Current plan</SectionHeader>
          {!isStaff && (
            <Button
              size={BUTTON_SIZES.sm}
              className="w-fit"
              onClick={toggleCurrentPlanModal}
            >
              Change plan
            </Button>
          )}
        </div>
        <CarePlansCard
          carePlans={carePlans}
          currentCarePlan={currentCarePlan}
        />
      </div>

      {!isStaff && (
        <ChangePlanModal
          show={currentPlanModal}
          onClose={toggleCurrentPlanModal}
          dateStarted={currentCarePlan.start_date}
          plan={currentCarePlan.provider_care_plan.name}
          currentCarePlanId={currentCarePlan.provider_care_plan.id}
        />
      )}
    </>
  );
};
